var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"backButton",attrs:{"color":"#5a6c72","elevation":"0","outlined":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t("message.cardsActions.backButton"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }